<template>
  <div class="withdraw_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('cash.withdraw') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/cashlist')"
      >
        <van-icon
          name="bars"
          size="25"
          color="#000"
        />
      </div>
    </div>
    <div class="balance ">
      <p>
        {{ $t('sky.jifen') }}
      </p>
      <p>
        {{ parseInt(data.money) }} 
      </p>
      <p>
        {{ $t('invest.availableBalance') }}   
      </p>
    </div>
    <!-- 		<div class="balance bglight" >
			<dl class="ratio-info ">
			    <dd><span class="text-gray">{{$t('cash.abletimes')}}：</span><em>{{data.cash_maxnum}} {{$t('cash.time')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.usdtimes')}}：</span><em>{{data.cashnum}} {{$t('cash.time')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.isable')}}：</span><em>{{$t('cash.yes')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.mincash')}}：</span><em>{{data.min_cash}} {{utils_moneyMark()}}</em></dd>
			</dl>
		</div> -->
    <div class="wrap_box wrap1 ">
      <div
        class="choose_bank bgdeep"
        @click="show=true"
      >
        <div>
          <span>{{ $t('cash.wallet') }}</span>
        </div>
        <div>
          <span>{{ bank_name }}</span>
          <van-icon
            name="arrow"
            color="#999"
          />
        </div>
      </div>
      <van-action-sheet
        v-model="show"
        :actions="actions"
        cancel-text=""
        :description="this.$t('cash.chooseWallet')"
        class="wallet-picker"
        closeable
        close-on-click-action
        :overlay-style="{ backgroundColor: 'rgba(6, 3, 2, .42)' }"
        @select="onSelect"
      />
      <div class="withdraw_wrap bgdeep">
        <p>{{ $t('cash.amount') }}</p>
        <div
          class="flex_center"
          style="justify-content: left;"
        >
          <span>{{ utils_moneyMark() }}</span>
          <input
            v-model="form.money" 
            type="number"
            step="1"
            class="inp"
            :placeholder="$t('pro2.enteramount')"
            @input="changeAmount"
          >
          <button
            class="allbtn"
            type="button"
            @click="cashall()"
          >
            {{ $t('item.all') }}
          </button>
					
          <!-- <span>{{actualAmount}}</span> -->
        </div>
        <p v-if="chargeTip">
          {{ chargeTip }}
        </p>
      </div>
      
      <!--      <div
        class="basic_btn"
        @click="submit()"
      >
        {{ $t('utils.submit') }}
      </div> -->
      <div
        class="basic_btn"
        @click="openPasswordInput(1)"
      >
        {{ $t('utils.submit') }}
      </div>
      <p class="canal_tips bglight">
        {{ $t('cash.arrivalTime') }}
      </p>
    </div>
    <!--   <div style="margin: 20px;line-height: 20px;text-align: center;margin-top: 50px;">
        	<img class="footimgs" src="../images/ban2/onekey__expedia.svg">
        	<img class="footimgs" src="../images/ban2/onekey__hotels__english.svg">
        	<img class="footimgs" src="../images/ban2/onekey__vrbo.svg">
        </div>
        <div class="footerdesc">
        	<div class="version">
        		Expedia 2025.46.1 (252432001)
        	</div>
        	<div class="copyright">
        	 © Hak Cipta 2012-2025 Expedia Group Semua hak cipta dilindungi undang-undang.
        	</div>
        </div> -->
    <van-popup
      v-model="write_psd"
      closeable
      close-icon="close"
      round
      position="bottom"
      class="password-popup"
      :close-on-click-overlay="false"
      :overlay-style="{ backgroundColor: 'rgba(6, 3, 2, .42)' }"
      @opened="showKeyboard = true"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <button
              v-for="i in 9"
              :key="i"
              type="button"
              class="key_item"
              @click.stop="onInput(i)"
            >
              <span class="key_inner">
                {{ i }}
              </span>
            </button>
            <button
              type="button"
              class="key_item no_bg clear"
              @click.stop="onClear"
            >
              <span class="key_inner">
                <van-icon name="clear" />
              </span>
            </button>
            <button
              type="button"
              class="key_item"
              @click.stop="onInput(0)"
            >
              <span class="key_inner">
                0
              </span>
            </button>
            <button
              type="button"
              class="key_item no_bg x"
              @click.stop="onDelete"
            >
              <span class="key_inner">
                <van-icon name="delete" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </van-popup>
    <div
      v-show="setPwd"
      class="real_name_mask"
    >
      <div class="real_box">
        <div class="tit" />
        <p class="tips">
          {{ $t('cash.setPwdFirst') }}
        </p>
        <div
          class="basic_btn"
          @click="setIniPwd"
        >
          {{ $t('cash.setNow') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Popup,
		PasswordInput,
		NumberKeyboard,
		Icon,
		ActionSheet
    } from 'vant';
    Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

    export default {
        name: "Cost",
        data() {
            return {
                data: {},
                showKeyboard: true,
                write_psd: false,
                psd_val: '',
				chargeTip:'',
				charge:0,
                form: {
                    money: '',
                    password: '',
                    bank_id: 0,
                },
				eye:1,
				show: false,
				bank_name:this.$t('cash.chooseWallet'),
				actions: [],
				setPwd:false,
				submitType:1,
				type:1,
				rate:1,
				mark:"$",
				actualAmount:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			cashall(){
				this.form.money = this.data.money;
				this.changeAmount();
			},
			onSelect(item){
				this.chargeTip = "";
				this.actualAmount = "";
				this.form.money = "";
				this.show = false;
				this.bank_name = item.name;
				this.form.bank_id = item.value;
				this.charge = item.charge;
				this.type = item.type;
				this.rate = item.rate;
				this.mark = item.mark;
				if(item.charge>0){
					this.chargeTip = this.$t('cash.charge')+item.charge+"%";
				}else{
					this.chargeTip = "";
				}
				if(item.value==0){
					this.$router.push('/addcountUsdt')
				}
			},
			changeAmount(){
				this.chargeTip = "";
				var rateTip = "";
				var num = 2;
					// if(this.type==1){
					// 	if(this.rate>10000){
					// 		num = 8;
					// 	}else if(this.rate>1000){
					// 		num = 6;
					// 	}else if(this.rate>10){
					// 		num = 4;
					// 	}
					// 	this.actualAmount = "≈"+(this.form.money/this.rate).toFixed(num)+this.mark;
					// 	rateTip = "≈"+(this.form.money*this.charge/100/this.rate).toFixed(num)+this.mark+"";
					// }else{
						this.actualAmount = "≈"+this.mark+(this.form.money/this.rate).toFixed(num);
						rateTip = "≈ "+(this.form.money*this.charge/100).toFixed(num)+" "+this.mark+"";
					// }
				if(this.charge>0){
					this.chargeTip = this.$t('cash.charge')+""+rateTip;
					// this.chargeTip = this.$t('cash.charge')+":$"+(this.form.money*this.charge/100).toFixed(num)+rateTip;
				}
			},
            onInput(key) {
                this.psd_val = (this.psd_val + key).slice(0, 6);
                if (this.psd_val.length == 6) {
					this.write_psd = false;
					this.form.password = this.psd_val;
					if(this.submitType==1){
						this.submit();
					}else{
						this.setIniPwdSubmit();
					}
					
                }
            },
            onDelete() {
                this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
            },
            onClear() {
                this.psd_val = '';
            },
            openPasswordInput(submitType) {
                this.submitType = submitType;
                this.psd_val = '';
                this.form.password = '';
                this.showKeyboard = true;
                this.write_psd = true;
            },
            subAll() {
                this.form.money = this.data.money;
            },
            start() {
                Fetch('/user/my_bank').then((r) => {
                    this.data = r.data;
					this.data.money = this.data.money.toFixed(0);
					this.setPwd = r.data.intPwd;
                    var bankvalue = [];
                    r.data.bank.forEach(item => {
						var length = item.account.length;
						var account = item.account+"";
						var itemAccount = account.substr(length-10,length)
                        bankvalue.push({
                            name: item.bank+"(****"+itemAccount+")",
                            value: item.id,
							charge:item.charge,
							rate:item.rate,
							type:item.type,
							mark:item.mark
                        })
                    })
					bankvalue.push({
					    name: this.$t('cash.addWallet'),
					    value: 0,
						color:"#FF0000",
					})
					this.actions = bankvalue;
					if(bankvalue.length>1){
						this.onSelect(bankvalue[0])
					}
                });
            },
            submit() {
				this.psd_val="";
                if (!this.form.money) {
                    this.$toast(this.$t('cash.withdrawalAmountEmpty'));
                    return false;
                }
                if(this.form.money < 0){
                    this.$toast(this.$t('cash.withdrawalAmountNotAllow'));
                    return false;
                }
				if(parseInt(this.form.money) > parseInt(this.data.money)){
                    this.$toast(this.$t('cash.withdrawalAmountHigh'));
                    return false;
                }
                if (this.form.bank_id == 0 || this.form.bank_id == -1) {
                    this.$toast(this.$t('cash.withdrawalAccountEmpty'));
                    return false;
                }
				if (!this.form.password || this.form.password.length!=6) {
                    this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
                    return false;
                }
                Fetch('/user/cost_apply', {
                    money: this.form.money,
                    bank_id: this.form.bank_id,
                    passwd: this.form.password
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('cash.success')
                    });
                    this.$router.replace('/user')
                });
            },
			setIniPwdSubmit(){
				this.psd_val="";
				Fetch('/user/setIniPwd', {
				    password: this.form.password
				}).then(() => {
					this.setPwd = false;
				});
			},
			setIniPwd(){
				this.openPasswordInput(2);
			}
        }
    };
</script>

<style lang="less" scoped>
	
	/deep/ .van-action-sheet__item {
	    text-align: left;
	}
	/deep/ .van-popup--bottom{
		border-radius:0;
		// padding-bottom: 15px;
	}
	.balance{
		border-radius: 6px;
		padding: 20px 0px;
		text-align: center;
		margin: 10px;
		border: 1px solid #CCC;
		p:nth-child(1){
			color: #000;
			font-size: 14px;
			margin-bottom: 15px;
		}
		p:nth-child(2){
			color: #000;
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 15px;
		}
		p:nth-child(3){
			color: #999;
			font-size: 14px;
			font-weight: bold;
		}
	}

    .wrap1 {
        margin: 10px;
		box-shadow: none;
		background: none;
		.choose_bank{
			width: 100%;
			background: #fff;
			border-radius: 5px;
			padding: 15px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 10px;
			border: 1px solid #CCC;
			div:nth-child(1){
				font-size: 14px;
				font-weight: bold;
				color: #282828;
			}
			div:nth-child(2){
				text-align: right;
				font-size: 12px;
				font-weight: bold;
				color: #282828;
			}
		}
		.withdraw_wrap{
			width: 100%;
			background: #fff;
			border-radius: 6px;
			padding: 16px;
			margin-top: 10px;
			border: 1px solid #CCC;
			input{
				height: 18px;
				width: 100%;
				line-height: 18px;
				font-size: 14px;
			}
			div{
				span:nth-child(1){
					width: 65px;
					font-size: 18px;
					margin-right: 10px;
					font-weight: bold;
				}
				span:nth-child(2){
					font-size: 14px;
					margin-left: 20px;
					font-weight: bold;
					width: 15%;
					color: #282828;
					text-align: right;
				}
			}
			p:nth-child(1){
				font-size: 14px;
				font-weight: bold;
				color: #282828;
				margin-bottom: 20px;
			}
			p:nth-child(3){
				color: #282828;
				margin-top: 20px;
			}
		
		}
    }
	.canal_tips {
		border-top: 1px solid #ECECEC;
		display: block;
		padding: 16px;
		border-radius: 5px;
		line-height: 24px;
		font-size: 12px;
		margin-top: 10px;
		background-color: #0063d2;
		color: #ffffff;
    }
    .basic_btn {
        margin: 53px auto 0 auto;
		border-radius: 5px;
    }

    /deep/ .van-password-input {
        margin: 50px 28px 0 28px;
    }

    /deep/ .van-hairline--left::after {
        border: 1px solid #ECECEC;
    }

    .van-password-input .van-password-input__security::after {
        border-radius: 0;
    }

    .keybord_box {
        height: 250px;
        background-color: #F0F0F0;
        margin-top: 35px;
        padding: 24px 12px 0 12px;

        .keybord {
            width: 361px;
            margin: 24px auto 0 atuo;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            text-align: center;

            .key_item {
                width: 115px;
                height: 44px;
                line-height: 44px;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 6px;
                background: rgba(255, 255, 255, 1);
                border-radius: 3px;

                &.no_bg {
                    background: none;
                }

                &.x {
                    color: #757880;
                    font-weight: bold;
                }
            }
        }
    }
	
	.ratio-info{
	    display: grid;
	    grid-template-columns: repeat(2,1fr);
	    row-gap: 14px;
	    padding: 0px 20px;
	    line-height: 1;
		dd{
		    margin: 0;
		}
		em {
		    font-style: normal;
		    font-size: 14px;
		}
	}
	.text-gray {
	    color: #ababab;
	}
	.basic_wrap{
		position: relative;
		height: 100vh;
	}
	/deep/ .van-popup--bottom{
		position: absolute;
	}
	.allbtn{
		height: 25px;
		line-height: 20px;
		padding: 2px 8px;
		border-radius: 5px;
		margin-left: 10px;
		font-size: 10px;
		background-color: #0063d2;
		color: #fff;
		width: 80px;
	}

	/* Scoped withdrawal page styling. */
	.withdraw_wrap { min-height: 100vh; height: auto; padding-bottom: calc(88px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #25100c, #120907 60%, #1b0b09); color: #f5dfbd; }.red_top_bg { height: 54px; background: rgba(27, 16, 13, .97); border-bottom: 1px solid rgba(185, 135, 59, .37); }.red_top_bg .big_tit, .red_top_bg .back_left, .red_top_bg .top_right /deep/ .van-icon { color: #eec97e !important; }
	.balance { margin: 14px; border-color: rgba(230, 182, 105, .54); border-radius: 16px; background: linear-gradient(135deg, #4c1610, #1c0d0a 70%); box-shadow: 0 14px 30px rgba(0, 0, 0, .28); }.balance p:nth-child(1), .balance p:nth-child(3) { color: #d9bd95; }.balance p:nth-child(2) { color: #f0c56d; font-size: 20px; }
	.wrap1 { margin: 0 14px; }.wrap1 .choose_bank, .wrap1 .withdraw_wrap { border-color: rgba(185, 135, 59, .44); border-radius: 13px; background: #1b100d; color: #ead0aa; }.wrap1 .choose_bank div:nth-child(1), .wrap1 .choose_bank div:nth-child(2), .wrap1 .withdraw_wrap p:nth-child(1), .wrap1 .withdraw_wrap p:nth-child(3) { color: #ead0aa; }.wrap1 .withdraw_wrap input { color: #f5dfbd; }.wrap1 .withdraw_wrap input::placeholder { color: #9a8067; }.wrap1 .withdraw_wrap div span:nth-child(1) { color: #e6b669; }.allbtn { border: 1px solid rgba(246, 210, 139, .56); background: #5f100d; color: #ffe4aa; }
	.basic_btn { height: 50px; margin-top: 28px; border: 1px solid rgba(246, 210, 139, .67); border-radius: 12px; background: linear-gradient(105deg, #710b0c, #a83219) !important; color: #ffe5ad !important; line-height: 48px; box-shadow: 0 9px 20px rgba(72, 8, 5, .26); }.canal_tips { border: 1px solid rgba(185, 135, 59, .35); background: #1b100d; color: #cdb18c; }
	/deep/ .van-action-sheet, /deep/ .van-popup--bottom { background: #1b100d; color: #f5dfbd; }.psw_box, .keybord_box { background: #1b100d; }.keybord_box .key_item { border: 1px solid rgba(185, 135, 59, .32); background: #28130e; color: #f5dfbd; }

	/* Refine the wallet picker and prevent the amount card from becoming a tall blank panel. */
	.wrap1 .withdraw_wrap { min-height: 0; padding: 17px 16px; }.wrap1 .withdraw_wrap .flex_center { min-height: 42px; border: 1px solid rgba(185, 135, 59, .32); border-radius: 9px; background: rgba(6, 3, 2, .28); padding: 0 10px; box-sizing: border-box; }.wrap1 .withdraw_wrap input { min-width: 0; height: 38px; }.wrap1 .withdraw_wrap p:nth-child(3) { margin: 11px 0 0; font-size: 12px; line-height: 20px; }
	.withdraw_wrap /deep/ .van-action-sheet { border: 1px solid rgba(230, 182, 105, .52); border-bottom: 0; border-radius: 18px 18px 0 0; background: #1b100d; overflow: hidden; }.withdraw_wrap /deep/ .van-action-sheet__header { height: 52px; color: #f0ca80; line-height: 52px; }.withdraw_wrap /deep/ .van-action-sheet__description { color: #c8aa83; }.withdraw_wrap /deep/ .van-action-sheet__content { background: #1b100d; }.withdraw_wrap /deep/ .van-action-sheet__item { min-height: 50px; border-top: 1px solid rgba(185, 135, 59, .18); color: #ead0aa; line-height: 50px; }.withdraw_wrap /deep/ .van-action-sheet__cancel { min-height: 54px; margin-top: 7px; border-top: 1px solid rgba(185, 135, 59, .28); background: #29130e; color: #e6b669; line-height: 54px; }.withdraw_wrap /deep/ .van-action-sheet__gap { height: 7px; background: #120907; }
	/deep/ .wallet-picker { border: 1px solid rgba(230, 182, 105, .52); border-bottom: 0; border-radius: 18px 18px 0 0; background: #1b100d !important; overflow: hidden; }.wallet-picker /deep/ .van-action-sheet__content, .wallet-picker /deep/ .van-action-sheet__action { background: #1b100d !important; }.wallet-picker /deep/ .van-action-sheet__item { min-height: 64px; padding: 0 20px; border-top: 1px solid rgba(185, 135, 59, .24); background: #1b100d !important; color: #ead0aa !important; line-height: 64px; text-align: left; }.wallet-picker /deep/ .van-action-sheet__item:active { background: #321710 !important; }.wallet-picker /deep/ .van-action-sheet__item:last-child { color: #ff7868 !important; }.wallet-picker /deep/ .van-action-sheet__description { height: 70px; color: #f0ca80; font-size: 16px; font-weight: 600; line-height: 70px; }.wallet-picker /deep/ .van-action-sheet__close { color: #e6b669; }
	.withdraw_wrap /deep/ .van-popup--bottom { position: fixed; }

	/* Password entry sheet: override legacy white keyboard rules with the same scoped depth. */
	.psw_box { min-height: 420px; padding-top: 1px; background: linear-gradient(160deg, #25100c, #150907); }.psw_box /deep/ .van-popup__close-icon { color: #e6b669; }.psw_box /deep/ .van-password-input__security { border: 1px solid rgba(185, 135, 59, .5); border-radius: 8px; overflow: hidden; }.psw_box /deep/ .van-password-input__security li { background: #1b100d; border-right-color: rgba(185, 135, 59, .32); }.psw_box /deep/ .van-password-input__security i, .psw_box /deep/ .van-password-input__cursor { background: #f0c56d; }
	.keybord_box { height: auto; min-height: 274px; margin-top: 28px; padding: 18px 12px calc(18px + env(safe-area-inset-bottom)); background: #1b100d; }.keybord_box .keybord { width: 100%; margin: 0 auto; gap: 7px 10px; }.keybord_box .keybord .key_item { width: calc((100% - 20px) / 3); height: 52px; margin-bottom: 0; border: 1px solid rgba(185, 135, 59, .38); border-radius: 8px; background: linear-gradient(145deg, #321710, #1b0d0a); color: #f1ca80; line-height: 50px; box-shadow: none; }.keybord_box .keybord .key_item.no_bg { border-color: transparent; background: transparent; }.keybord_box .keybord .key_item.no_bg.x { color: #e6b669; }
	.password-popup { max-width: 600px; background: #1b100d; }.keybord_box .keybord button.key_item { appearance: none; padding: 0; font-family: inherit; cursor: pointer; touch-action: manipulation; }.keybord_box .keybord button.key_item:active { transform: scale(.98); background: #482116; }.keybord_box .keybord button.key_item.no_bg.clear, .keybord_box .keybord button.key_item.no_bg.x { border-color: rgba(185, 135, 59, .38); background: #28130e; }

	/* Final ivory theme overrides for withdrawal and its picker/password panels. */
	.withdraw_wrap { background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); color: #533126; }.red_top_bg { background: rgba(255, 252, 245, .97); border-bottom-color: rgba(190, 139, 52, .45); }.red_top_bg .big_tit, .red_top_bg .back_left, .red_top_bg .top_right /deep/ .van-icon { color: #8f251d !important; }
	.balance { border-color: rgba(190, 139, 52, .55); background: linear-gradient(135deg, #fffdf8, #f7deb0 105%); box-shadow: 0 14px 30px rgba(126, 84, 29, .12); }.balance p:nth-child(1), .balance p:nth-child(3) { color: #815c45; }.balance p:nth-child(2) { color: #a6233d; }
	.wrap1 .choose_bank, .wrap1 .withdraw_wrap, .canal_tips { border-color: rgba(190, 139, 52, .5); background: #fffdf8; color: #533126; }.wrap1 .choose_bank div:nth-child(1), .wrap1 .choose_bank div:nth-child(2), .wrap1 .withdraw_wrap p:nth-child(1), .wrap1 .withdraw_wrap p:nth-child(3), .wrap1 .withdraw_wrap input { color: #533126; }.wrap1 .withdraw_wrap input::placeholder { color: #9c8068; }.wrap1 .withdraw_wrap .flex_center { border-color: rgba(190, 139, 52, .32); background: #fff8e9; }.wrap1 .withdraw_wrap div span:nth-child(1), .allbtn { color: #a6233d; }.allbtn { border-color: #b9802e; background: #fff1cd; }
	.basic_btn { border-color: #b9802e; background: linear-gradient(105deg, #a6233d, #ca5a5b) !important; color: #fff9ea !important; box-shadow: 0 9px 20px rgba(151, 17, 56, .18); }
	/deep/ .van-action-sheet, /deep/ .van-popup--bottom, .psw_box, .keybord_box, .password-popup { background: #fffdf8; color: #533126; }.withdraw_wrap /deep/ .van-action-sheet, /deep/ .wallet-picker { border-color: rgba(190, 139, 52, .55); background: #fffdf8 !important; }.withdraw_wrap /deep/ .van-action-sheet__header, .wallet-picker /deep/ .van-action-sheet__description { color: #8f251d; }.withdraw_wrap /deep/ .van-action-sheet__description, .withdraw_wrap /deep/ .van-action-sheet__item, .wallet-picker /deep/ .van-action-sheet__item { background: #fffdf8 !important; color: #533126 !important; }.withdraw_wrap /deep/ .van-action-sheet__cancel { background: #fff1cd; color: #a6233d; }.withdraw_wrap /deep/ .van-action-sheet__gap { background: #f7e6c5; }.wallet-picker /deep/ .van-action-sheet__close, .psw_box /deep/ .van-popup__close-icon { color: #a6233d; }
	.psw_box /deep/ .van-password-input__security li, .keybord_box .keybord .key_item, .keybord_box .keybord button.key_item.no_bg.clear, .keybord_box .keybord button.key_item.no_bg.x { border-color: rgba(190, 139, 52, .42); background: #fff8e9; color: #8f251d; }.psw_box /deep/ .van-password-input__cursor, .psw_box /deep/ .van-password-input__security i { background: #b9802e; }
</style>
